<template>
  <div class="tariff_component main_container">
    <transition name="fade">
      <ModalBuyCourse
          v-if="modalBuyCourse.show"
          :isOldVersion="isOldVersion"
          :nextRoute="getNextRouteModalBuyCourse"
          :vk_is_used="vkIsUsed"
          :paymentData="paymentData"
          v-model:installment="installmentData"
          :runSuccessfullyPayFunc="modalBuyCourse.runSuccessfullyFunction"
          @close="closeModalBuyCourse"
      >
      </ModalBuyCourse>
    </transition>
    <transition name="fade">
      <ModalNotification
        v-if="notification.show"
        :timeShowNotification="6"
        :textNotification="notification.text"
        :typeNotification="notification.type"
        @close="closeModalNotification"
      ></ModalNotification>
    </transition>

    <div class="block block__column block-content">
      <HeaderPoint
        :currentStep="currentStep"
        :keyRate="keyRate"
        :typeHeaderPoint="typeHeaderPoint"
      ></HeaderPoint>

      <MobileStepInfo
        class="block block__theme_mobile-steps"
        :title="'Выбор тарифа'"
        :currentStep="1"
      ></MobileStepInfo>

      <!--   таймер обратного отсчета до повышения тарифного плана   -->
      <transition name="fade">
        <div class="sidebar_item block_timer__tablet block_timer__mobile_tablet"
             v-if="showTimer"
        >
          <!--     До повышения цен осталось:       -->
          <div class="sidebar_header">До повышения цен осталось:</div>

          <div class="sidebar_border"></div>

          <div class="timer_row">
            <div class="timer_item">
              <div class="timer_meaning">{{timer.days}}</div>
              <div class="timer_clarification">дней</div>
            </div>

            <div class="timer_dots">
              <div class="timer_dot"></div>
              <div class="timer_dot"></div>
            </div>

            <div class="timer_item">
              <div class="timer_meaning">{{timer.hours}}</div>
              <div class="timer_clarification">часов</div>
            </div>

            <div class="timer_dots">
              <div class="timer_dot"></div>
              <div class="timer_dot"></div>
            </div>

            <div class="timer_item">
              <div class="timer_meaning">{{timer.minutes}}</div>
              <div class="timer_clarification">минут</div>
            </div>

            <div class="timer_dots">
              <div class="timer_dot"></div>
              <div class="timer_dot"></div>
            </div>

            <div class="timer_item">
              <div class="timer_meaning">{{timer.seconds}}</div>
              <div class="timer_clarification">секунд</div>
            </div>
          </div>
        </div>
      </transition>

      <WaitingLoading
        v-show="!dataReceived"
        :showComponent="!dataReceived"
        :isLoadedForAllPage="true"
      ></WaitingLoading>

      <!-- контент  -->
      <transition name="fadeOut">
        <PGKSelectTariff
          class="select-tariff-component"
          v-if="dataReceived && (productName === 'pgk')"
          :promoCodeApplied="promoCodeApplied"
          v-model:promoCode="promoCode"
          v-model:firstSwitchActive="isFirstSwitchActive"
          :idSelectedTariff="activeTariff"
          :listTariff="listTariffPGK"
          :featureList="featureListPGK"
          @changeSwitch="changeSwitchPGK"
          @changeTariff="changeTariffPGK"
          @applyPromoCode="applyPromoCode"
          @removePromoCode="removePromoCode"
        ></PGKSelectTariff>
      </transition>

      <transition name="fadeOut">
        <DefaultSelectTariff
          class="select-tariff-component"
          v-if="dataReceived && (productName === 'gk')"
          :isOldVersion="isOldVersion"
          :bonusData="bonusData"
          :activeTariff="activeTariff"
          :activePackage="activePackage"
          :tariffList="tariffList"
          v-model:typeTutor="activeTypeTutor"
          :promoCodeApplied="promoCodeApplied"
          :benefitApplied="benefitApplied"
          v-model:promoCode="promoCode"
          :showSelectTutor="showSelectTutor"
          :listPrize="listPrize"
          @closeDiscountComponent="closeDiscountComponent"
          @setTutor="setTutor"
          @choiceTariff="choiceTariff"
          @choicePackage="choicePackage"
          @applyPromoCode="applyPromoCode"
          @removePromoCode="removePromoCode"
        ></DefaultSelectTariff>
      </transition>
    </div>
    <div class="block block__column">
      <CheckBar
          class="block_management"
          :checkbar="checkbar"
          :info="infoCheckBar"
          :buttons="buttons"
          @goToNextStep="openModalBuyCourse"
      >
      </CheckBar>

      <transition name="fade">
        <div class="sidebar_item block_timer__desktop"
             v-if="showTimer"
        >
          <!--     До повышения цен осталось:       -->
          <div class="sidebar_header">До повышения цен осталось:</div>

          <div class="sidebar_border"></div>

          <div class="timer_row">
            <div class="timer_item">
              <div class="timer_meaning">{{timer.days}}</div>
              <div class="timer_clarification">дней</div>
            </div>

            <div class="timer_dots">
              <div class="timer_dot"></div>
              <div class="timer_dot"></div>
            </div>

            <div class="timer_item">
              <div class="timer_meaning">{{timer.hours}}</div>
              <div class="timer_clarification">часов</div>
            </div>

            <div class="timer_dots">
              <div class="timer_dot"></div>
              <div class="timer_dot"></div>
            </div>

            <div class="timer_item">
              <div class="timer_meaning">{{timer.minutes}}</div>
              <div class="timer_clarification">минут</div>
            </div>

            <div class="timer_dots">
              <div class="timer_dot"></div>
              <div class="timer_dot"></div>
            </div>

            <div class="timer_item">
              <div class="timer_meaning">{{timer.seconds}}</div>
              <div class="timer_clarification">секунд</div>
            </div>
          </div>
        </div>
      </transition>

      <div class="sidebar_item block_promocode__desktop">
        <div class="sidebar_header">Промокод</div>

        <div class="sidebar_border"></div>

        <div class="block_promo">
          <div class="block block__row block__position_relative">
            <input name="promo_code"
                   class="promo_input"
                   v-model="promoCode"
                   :disabled="promoCodeApplied"
                   type="text"
                   placeholder="Введите промокод"
                   @keydown.enter="applyPromoCode()"
            />

            <transition name="fade">
              <div class="button button__type_remove"
                   v-if="promoCodeApplied"
                   @click="removePromoCode()"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.2502 0L6.99938 5.25L1.74984 0L0 1.75L5.24954 7L0 12.25L1.74984 14L6.99938 8.75L12.2502 14L14 12.25L8.75046 7L14 1.75L12.2502 0Z" fill="white" fill-opacity="1"/>
                </svg>
              </div>
            </transition>
          </div>

          <div class="promo_button"
               :class="(!promoCodeApplied && (promoCode.length > 0))?('promo_button__active'):(
                   (promoCodeApplied)?('promo_button__applied'):('')
                   )"
               @click="applyPromoCode()"
          >
            <transition name="out-in">
              <div class="promo_svg" v-if="!promoCodeApplied">
                <svg width="22" height="22" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.98098 9.3431L10.3044 9.0001L9.98098 8.65709L6.6872 5.1637L7.19141 4.62894L11.3128 9.0001L7.19141 13.3712L6.6872 12.8365L9.98098 9.3431Z" fill="#ABABB2" stroke="#ABABB2"/>
                </svg>
              </div>

              <div class="promo_svg" v-else>
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.98357 13.1016L6.0578 10.1758L5.96499 10.083L5.87218 10.1758L4.57602 11.472L4.48321 11.5648L4.57602 11.6576L8.89077 15.9724L8.98357 16.0652L9.07638 15.9724L17.9745 7.07428L18.0673 6.98147L17.9745 6.88866L16.6783 5.59249L16.5855 5.49969L16.4927 5.59249L8.98357 13.1016Z" fill="white" stroke="white" stroke-width="0.2625"/>
                </svg>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileStepInfo from "../../DefaultBlock/MobileStepInfo";
import { Swiper, SwiperSlide } from 'swiper/vue';;
import 'swiper/css';
import ModalBuyCourse from "../../ModalWindows/modalBuyCourse";
import ModalNotification from '../../../../DefaultComponents/ModalWindows/ModalNotification';
import HeaderPoint from '../../DefaultBlock/HeaderPoint.vue';
import CheckBar from "../../../../DefaultComponents/CheckBar.vue";
import {tariffLogo} from '@/svgStoreFiles';
import {send} from "../../../../fetchData";
import WaitingLoading from '@/components/DefaultComponents/WaitingLoading.vue';

import OfferToBuyComponent from '@/components/DefaultComponents/BlockComponents/OfferToBuyComponent.vue';
import BlockInfoCredit from "../../DefaultBlock/BlockInfoCredit";
import DefaultSelectTariff from "./Composables/DefaultSelectTariff";
import PGKSelectTariff from "./Composables/PGKSelectTariff";
import {emitter} from "../../../../databus";
import {pluralize} from "@/helpers/htmlContext/text";
import {checkShowSlicedGKHeader} from "../defaultFunctions";
import {setYandexMetric} from "@/helpers/pay/metric/yandexMetric";

export default {
  name: "TariffComponent",

  data() {
    return {
      productName: '', // наименование продукта / gk - годовой курс / pgk - полугодовой курс
      modalBuyCourse: {
        show: false,
        runSuccessfullyFunction: false, // запустить ли функцию успешной оплаты при открытии модального окна покупки курсов? Используется при оплате через Yandex Pay
      },
      vkIsUsed: '',
      dataReceived: false, // данные от апи получены?
      currentStep: 1, // текущий шаг оплат на котором располагается данный компонент
      keyRate: 0,
      typeHeaderPoint: 'full', // тип хлебных крошек / full - полный / sliced - обрезанный
      idsTariffWithSelectTutor: [], // для ПГК id тарифов, где доступен выбор репетиторов
      isOldVersion: true, // это старая версия стр. оплат?

      notification: { // модальное окно уведомлений
        show: false,
        text: '',
        type: ''   // successfully / error / itemUp
      },

      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 12,
        pagination: {
          clickable: true
        }
      },

      checkbar: [
        {
          id: 0,
          name: 'Тариф',
          check: true,
        }
      ],

      infoCheckBar: null,

      buttons: [
        {
          id: 0,
          type: 'active', // типы кнопок 1 - blocked кнопка заблокирован, 2 - active кнопка активна, 3 - skip пропустить шаг
          name: 'Перейти на следующий шаг',
          typeButton: 1,
        }
      ],

      paymentData: { // данные для оплат
        idExam: undefined, // id экзамена
        idCourse: undefined, // id курса
        type: 'gk', // тип оплаты / gk - гк и ои / pgk - пгк
        idPrice: null, // id стоимости
        price: undefined, // стоимость к оплате
        priceText: '', // стоимость к оплате в текстовом формате
        idOrder: null, // id заказа
        idStock: undefined, // id текущего активного тарифа
        activeTypeTutor: undefined, // активный тип репетиторов
        teacherType: undefined, // тип репетитора, на который распространяется промокод / -1 - не зависит от типа / 0 - только для стандарт / 1 - только для топ
        enableSelectTeacher: true, // доступен ли выбор репетитора
        courseName: '', // наименование курса
        tariffName: '', // наименование тарифа
        packageName: '', // наименование пакета
        promoCode: null, // текст промокода если он есть, если нет то null или false
        specialPromo: '', // текст промокода спец. оффера (например после покупки Академии РИ)
        discountSpecialPromo: 0, // сумма скидки по спец офферу
        idTariffPromoCode: undefined, // для каких тарифов применяется данный промокод
        timeEndPromoCode: undefined, // время окончания действия промокода
        pricesTop: null, // Объект новых цен топового репетитора. Ключ - ID пакета, значение - новая цена
        pricesStandard: null, //  Объект новых цен стандартного репетитора. Ключ - ID пакета, значение - новая цена
        isAccessCredit: undefined, // доступна ли рассрочка
        prices: undefined, // объект цен и тарифов для огненного итогового, для пгк
        countMonth: undefined, // кол-во месяцев
        idsTariffWithSelectTutor: [], // id тарифов, на которых доступен выбор репетитора
      },

      showTimer: false,
      timer: {   // таймер обратного отсчета до повышения цен
        seconds: '00',
        minutes: '00',
        hours: '00',
        days: '00',
        timeEnd: '00',
      },

      promoCodeApplied: false, // применен промокод?
      benefitApplied: false, // применена скидка при покупке 2-го предмета?
      promoCode: '', // текст промокода

      topTutorExplanation: 'ТОП-репетитор — это репетитор, который подготовил стобалльников, а также занимает лидирующие позиции по среднему баллу в рейтинге репетиторов', // пояснение "Кто такой топовый репетитор?"
      topTutorExplanationOpen: false, // открыто пояснение по топовому репетитору
      activeTariff: undefined, // id активного тарифного плана
      activePackage: undefined, // id активного пакета
      activeTypeTutor: 'topTutor', // активный тип репетиторов
      oldTypeTutor: '', // старый тип репетиторов, нужен для восстановления типа репетитора после смены на вариант, где выбор репетитора не требуется
      isBuyTop: true, // доступна ли покупка топ репетитора
      isBuyStandard: true, // доступна ли покупка стандарт репетитора
      currentCost: 0, //  итого к оплате

      bonusData: { // данные для скидки на 2-й предмет
        isActive: false, // активна ли скидка
        text: '',
        discount: 0, // сумма скидки
        stockIds: [], // массив с id курсов, к которым применена скидка / -1 - скидка применена ко всем
        promo: '', // наименование промокода
        timeEnd: undefined, // время окончания действия скидки
      },

      pgkCountMonth: { // кол-во месяцев в пгк
        min: 1,
        max: 4,
      },

      isFirstSwitchActive: false, // активен 1-й switch
      listTariffPGK: [ // список курсов
       /* {
          id: 0,
          title: 'Слизерин',
          description: 'Максимально самостоятельный тариф с практиками \n' +
            'в формате вебинаров, ДЗ с автопроверкой и общим чатом факультета.',
          image: '/img/anyImg/tariffLogo.svg',
          oldCost: 6000,
          oldCostString: '6 000',
          cost: 5500, // стоимость
          costString: '5 500',
          benefit: 1500, // выгода
          benefitString: '1 500',
          saleBenefit: 2500, // выгода со скидкой
          saleBenefitString: '2 500',
          installmentAvailable: false, // доступна рассрочка
          countMonth: 1, // кол-во месяцев
          featureList: { // список преимуществ
            100: {
              type: 'text', // тип / text - в виде текста / svg - в виде svg
              value: '8 занятий',
            },
          }
        },*/
      ],
      featureListPGK: [ // список особенностей тарифов ПГК
       /* {
          id: 1,
          title: 'Основной курс',
          children: [
            {
              id: 100,
              title: 'Теоретические занятия в записи',
            },
          ]
        },*/
      ],
      listPrize: {},
      tariffList: [
        // {
        //   id: 0,
        //   title: 'Минимум',
        //   topTutor: {
        //     benefit: 2300,
        //     cost: 599,
        //     oldCost: undefined,
        //     benefitText: '2 300',
        //     costText: '599',
        //     oldCostText: undefined,
        //   },
        //   standardTutor: {
        //     benefit: 300,
        //     cost: 499,
        //     oldCost: 599,
        //     benefitText: '2 300',
        //     costText: '599',
        //     oldCostText: undefined,
        //   },
        //   svg: tariffLogo.minimum,
        // },
      ],

      showSelectTutor: true,
      typeCourse: '', // тип курса, который оплачивают
      showModalWaitingQuery: false, // показать модальное окно ожидания загрузки
      installmentData: {  // данные по рассрочкам (по доступным)
        id: null, // идентификатор заказа
        showcaseId: '',
        shopId: '',
        orderId: '',
        min: 1,
        max: null,
        selectedMonth: 1,
        list: [], // список промокодов (месяцев) для рассрочек
        amount: null, // итоговая стоимость
      },
    }
  },

  created() {
    let url = window.location.hash.substring(1)
    if (url === 'invalid_vk_is_used'){
      this.vkIsUsed = 'invalid_vk_is_used'
    }

    this.getData();

    this.paymentData.courseName = this.$store.state.allCourses[Number(this.$route.params.idCourse)].title;

    if (this.$route.query.status && (this.$route.query.status === 'reject')) {
      this.openErrorModal('Ошибка! В заявке на оформление рассрочки было отказано');
      this.clearQuery();
    }
  },

  mounted() {

  },

  watch: {
    '$route'(after, before) {
      if (after.name === 'buySelectTariff') {
        this.getData();

        this.paymentData.courseName = this.$store.state.allCourses[Number(this.$route.params.idCourse)].title;
      }
    },

    // Смена позиции switch
    isFirstSwitchActive(after) {
      this.setActiveTariff();
    },
  },

  methods: {
    // получить данные для стр. с тарифами
    getData() {
      this.promoCodeApplied = false;
      this.isOldVersion = true;
      this.tariffList = [];
      this.listTariffPGK = [];
      this.featureListPGK = [];
      let idCourse = Number(this.$route.params.idCourse);

      // получение данных для ГК и ОИ
      let getDataDefault = () => {
        let data;

        let isValid = (value) => value !== null && value !== undefined && value !== '';

        switch (this.$route.params.typePlatform) {
          case 'ff': // итоговое сочинение
            let dataUtm = '';

            if (sessionStorage.getItem('finalEssay')) {
              dataUtm = JSON.parse(sessionStorage.getItem('finalEssay'));
            }

            let isValidUtm = isValid(dataUtm);

            data = {
              module: 'get_stock',
              is_show_hidden_stocks: isValidUtm && dataUtm.type && Number(dataUtm.type) === 1,
              promo: isValidUtm && dataUtm.promo ? dataUtm.promo : null,
            };

            send
              .post("final_essay.php", data)
              .then((response) => {
                console.log('get_stock');
                console.log(response);

                this.setDataWithTypeTutors(response, idCourse, 'finalEssay');
              })
              .catch((error) => {
                console.log('error get_stock');
                console.log(error.response);
                console.log(error);
              });
            break;

          default: // ГК
            data = {
              module: 'get_stock',
              course_id: idCourse
            };

            send
              .post("course.php", data)
              .then((response) => {
                console.log('get_stock');
                console.log(response);

                this.setDataWithTypeTutors(response, idCourse);
              })
              .catch((error) => {
                console.log('error get_stock');
                console.log(error.response);
                console.log(error);
              });
        }
      };

      // получение данных для ПГК
      let getDataPGK = () => {
        let data = {
          module: 'get_stock',
          course_id: idCourse
        };

        send
          .post("semi_course.php", data)
          .then((response) => {
            console.log('get_stock pgk');
            console.log(response);

            this.setDataWithMonth(response, idCourse);
          })
          .catch((error) => {
            console.log('error get_stock');
            console.log(error.response);
            console.log(error);
          });
      };
      
      switch (this.$route.name) {
        case 'pgkBuySelectTariff':
          this.productName = 'pgk';
          getDataPGK();
          break;

        default:
          this.productName = 'gk';
          getDataDefault();
      }
    },

    /** Возвращает стоимость строкой
     * @param {Number, String} cost - стоимость
     * @returns стоимость текстом
    * */
    getStringCost(cost) {
      if ((cost === undefined) || (cost === null)) return cost
      let textCost = String(cost);

      if (textCost.length > 3) {
        let textCostSplit = textCost.split('');
        textCostSplit.splice(-3, 0, ' ');

        return textCostSplit.join('');
      }

      return textCost
    },

    // открыть / скрыть окно с ожидаием загрузки
    visibleWaitingComponent(isShow) {
      this.showModalWaitingQuery = isShow; // показать модальное окно ожидания загрузки
      emitter.emit('managementGlobalWaiting', isShow);
    },

    /** Установить данные для функционала оплат с месяцами для ПГК
     * */
    setDataWithMonth(response, idCourse) {
      // вернуть список тарифов
      let getIdsTariff = (stocks) => {
        return stocks.reduce((accumulator, currentValue) => {
          if (currentValue.is_access_select_teacher) {
            return [...accumulator, currentValue.id]
          }

          return accumulator
        }, [])
      };

      this.idsTariffWithSelectTutor = getIdsTariff(response.stocks);

      this.paymentData.idsTariffWithSelectTutor = this.idsTariffWithSelectTutor;
      this.dataReceived = true;
      this.activeTariff = undefined;
      this.benefitApplied = false;
      this.bonusData.isActive = false;
      this.bonusData.discount = 0;
      this.bonusData.stockIds = [];
      this.bonusData.promo = '';
      this.bonusData.timeEnd = 0;
      this.bonusData.text = '';

      // получение данных для преимуществ
      let getFeatureData = (typeDescriptions, idMultiplier) => {
        let featureListPGK = [];
        let tariffFeatureList = {}; // объект преимуществ тарифа

        typeDescriptions.forEach((item, i) => {
          let itemChildren = [];

          item.children.forEach((children, j) => {
            let childrenId = (idMultiplier * item.id) + children.id
            itemChildren.push({
              id: childrenId,
              title: children.title,
            });

            Object.entries(children.values).forEach(([key, value]) => {
              let feature = {
                type: (typeof value === 'boolean')?('svg'):('text'), // тип / text - в виде текста / svg - в виде svg
                value: value,
              }

              if (tariffFeatureList[key]) {
                Object.assign(tariffFeatureList[key], {
                  [childrenId]: feature,
                })
              } else {
                tariffFeatureList[key] = {
                  [childrenId]: feature,
                }
              }
            });

          });

          featureListPGK.push({
            id: item.id,
            title: item.title,
            children: itemChildren,
          });
        });

        return {
          featureList: featureListPGK,
          tariffFeatureList: tariffFeatureList,
        }
      };

      // получить список цен повышения
      let getNextPriceList = (stocksNext) => {
        let nextPriceList = {};

        stocksNext.forEach((item, i) => {
          nextPriceList[item.type_id] = item.price;
        });

        return nextPriceList
      };

      // получить список тарифов ПГК
      let getListTariffPGK = (stocks, stocksNext, tariffFeatureList) => {
        let nextPriceList = getNextPriceList(stocksNext);

        return stocks.map((item, i) => {
          let benefit = undefined;

          if (nextPriceList[item.id]) {
            benefit = nextPriceList[item.id] - item.price;
            if (benefit < 0) benefit = 0;
          }

         return {
            id: item.id,
            courseId: item.course_id,
            localId: item.local_id,
            title: item.type_name,
            description: item.description,
            image: item.img.full_link,
            oldCost: item.price,
            oldCostString: this.getStringCost(item.price),
            cost: item.price, // стоимость
            costString: this.getStringCost(item.price),
            benefit: benefit, // выгода
            benefitString: this.getStringCost(benefit),
            saleBenefit: undefined, // выгода со скидкой
            saleBenefitString: undefined,
            installmentAvailable: item.is_access_credit, // доступна рассрочка
            countMonth: item.count_month, // кол-во месяцев
            featureList: tariffFeatureList[item.id],
          };
        });
      };

      const idMultiplier = 1000; // множитель id

      let featureData = getFeatureData(response.type_descriptions, idMultiplier);
      this.featureListPGK = featureData.featureList;
      this.listTariffPGK = getListTariffPGK(response.stocks, response.stocks_next, featureData.tariffFeatureList);
      this.setActiveTariff();
      this.managementUTMPromoCode();
    },

    /** Установить данные по промокоду (применить промокод из utm)
     * @returns Возвращает undefined при выходе их функции
    * */
    managementUTMPromoCode() {
      let promo = JSON.parse(sessionStorage.getItem('utmPromoCode'))?.promo;
      if (!promo) return;

      this.promoCode = promo;
      this.applyPromoCode(true);
      sessionStorage.removeItem('utmPromoCode');
    },

    /** Установить данные по тарифам для старой страницы (старого функционала)
     * @param {Object} response - данные результата запроса
     * @param {Number} idCourse- id курса
     * @param {String} typeData - тип данных ГК / ПГК
    * */
    setOldTariffData(response, idCourse, typeData = 'gk') {
      // Получить список бонусов тарифа в заданном формате
      let getSpecialAspectsTariff = (specialAspects) => {
        return specialAspects.map((item, i) => {
          return {
            idPoint: item.option_id,
            isEnabled: item.is_enabled ?? true, // TODO: Добавить параметр с бека
            text: item.options
          }
        });
      };

      let discount = this.bonusData.discount;
      this.typeHeaderPoint = (checkShowSlicedGKHeader(response.steps))?('sliced'):('full');

      response.stocks.forEach((item, i) => {
        let applyDiscount = this.benefitApplied && ((this.bonusData.stockIds === -1) || (this.bonusData.stockIds.includes(item.type_id))); // применить скидку для данного пакета

        let indexAddedId = undefined; // этот id уже есть в массиве / хранится index элемента

        if (typeData === 'gk') {
          for (let i = 0; i < this.tariffList.length; i++) {
            if (this.tariffList[i].id === item.type_id) {
              indexAddedId = i;
            }
          }
        }

        let nextPriceAll = undefined;
        if (response.stocks_next) {
          for (let i = 0; i < response.stocks_next.length; i++) {
            let typeId = null;

            switch (typeData) {
              case 'gk':
                typeId = item.type_id;
                break;

              case 'finalEssay':
                typeId = item.id;
                break;
            }

            if ((response.stocks_next[i].type_id === typeId) && (response.stocks_next[i].teacher_type === item.teacher_type)) {
              nextPriceAll = response.stocks_next[i].price;
              break;
            }
          }
        }

        if (indexAddedId === undefined) { // этот элемент пока не добавлен
          let svg = undefined;
          let topTutor = {
            benefit: undefined,
            defaultBenefit: undefined,
            idPrice: undefined,
            cost: undefined,
            oldCost: undefined,
            benefitText: undefined,
            costText: undefined,
            oldCostText: undefined,
            isAccessCredit: undefined, // доступна ли рассрочка
          };
          let standardTutor = {
            benefit: undefined,
            idPrice: undefined,
            cost: undefined,
            oldCost: undefined,
            benefitText: undefined,
            costText: undefined,
            oldCostText: undefined,
            isAccessCredit: undefined, // доступна ли рассрочка
          };

          let benefit = (response.stocks_next && (response.stocks_next.length > 0))?(nextPriceAll - item.price):(undefined);

          if ((item.teacher_type === 0) || (typeData === 'finalEssay')) {  // стандартный репетитор
            standardTutor.isAccessCredit = item.is_access_credit;
            standardTutor.cost = (applyDiscount)?(item.price - discount):(item.price);
            standardTutor.oldCost = item.price;
            standardTutor.idPrice = item.global_price_id;
            standardTutor.benefit = (applyDiscount && (discount > 0))?(discount):(benefit);
            standardTutor.defaultBenefit = (response.stocks_next && (response.stocks_next.length > 0))?(nextPriceAll - item.price):(undefined);

            standardTutor.costText = this.getStringCost(standardTutor.cost);
            standardTutor.oldCostText = this.getStringCost(item.price);
            standardTutor.benefitText = this.getStringCost((standardTutor.benefit && (standardTutor.benefit > 0))?(String(standardTutor.benefit)):(''));
          } else { // топовый репетитор
            topTutor.isAccessCredit = item.is_access_credit;
            topTutor.cost = (applyDiscount)?(item.price - discount):(item.price);
            topTutor.oldCost = item.price;
            topTutor.idPrice = item.global_price_id;
            topTutor.benefit = (applyDiscount && (discount > 0))?(discount):(benefit);
            topTutor.defaultBenefit = (response.stocks_next && (response.stocks_next.length > 0))?(nextPriceAll - item.price):(undefined);

            topTutor.costText = this.getStringCost(topTutor.cost);
            topTutor.oldCostText = this.getStringCost(item.price);
            topTutor.benefitText = this.getStringCost((topTutor.benefit && (topTutor.benefit > 0))?(String(topTutor.benefit)):(''));
          }

          if (typeData === 'gk') {
            switch (item.type_id) {
              case 1: // Минимальный
                svg = tariffLogo.minimum;
                break;

              case 2: // Базовый
                svg = tariffLogo.standard;
                break;

              case 3: // Премиальный
                svg = tariffLogo.standardPlus;
                break;

              case 4: // Платиновый
                svg = tariffLogo.premium;
                break;
            }
          } else if (typeData === 'finalEssay') {
            switch (item.id) {
              case 1: // Минимальный
                svg = tariffLogo.profi;
                break;

              case 2: // Минимальный
                svg = tariffLogo.minimum;
                break;

              case 3: // Базовый
                svg = tariffLogo.standard;
                break;

              case 4: // Премиальный
                svg = tariffLogo.standardPlus;
                break;

              case 5: // Платиновый
              case 69:
                svg = tariffLogo.premium;
                break;
            }
          }

          let idPoint = null;

          switch (typeData) {
            case 'gk':
              idPoint = item.type_id;
              break;

            case 'finalEssay':
              idPoint = item.id;
              break;
          }

          this.tariffList.push({
            id: idPoint,
            title: item.type_name,
            countLessons: item.count_lessons,
            topTutor: topTutor,
            standardTutor: standardTutor,
            tariffSpecialAspects: getSpecialAspectsTariff(item.types_descriptions),
            svg: svg,
          })
        } else {
          let benefit = (response.stocks_next && (response.stocks_next.length > 0))?(nextPriceAll - item.price):(undefined)

          if (item.teacher_type === 0) { // стандартный репетитор
            this.tariffList[indexAddedId].standardTutor.isAccessCredit = item.is_access_credit;
            this.tariffList[indexAddedId].standardTutor.cost = (applyDiscount)?(item.price - discount):(item.price);
            this.tariffList[indexAddedId].standardTutor.oldCost = item.price;
            this.tariffList[indexAddedId].standardTutor.idPrice = item.global_price_id;
            this.tariffList[indexAddedId].standardTutor.benefit = (applyDiscount && (discount > 0))?(discount):(benefit);
            this.tariffList[indexAddedId].standardTutor.defaultBenefit = (response.stocks_next && (response.stocks_next.length > 0))?(nextPriceAll - item.price):(undefined);

            this.tariffList[indexAddedId].standardTutor.costText = this.getStringCost(this.tariffList[indexAddedId].standardTutor.cost);
            this.tariffList[indexAddedId].standardTutor.oldCostText = this.getStringCost(item.price);

            this.tariffList[indexAddedId].standardTutor.benefitText = this.getStringCost(
              (
                this.tariffList[indexAddedId].standardTutor.benefit &&
                (this.tariffList[indexAddedId].standardTutor.benefit > 0)
              )?(this.tariffList[indexAddedId].standardTutor.benefit):('')
            );
          } else {  // топовый репетитор
            this.tariffList[indexAddedId].topTutor.isAccessCredit = item.is_access_credit;
            this.tariffList[indexAddedId].topTutor.cost = (applyDiscount)?(item.price - discount):(item.price);
            this.tariffList[indexAddedId].topTutor.oldCost = item.price;
            this.tariffList[indexAddedId].topTutor.idPrice = item.global_price_id;
            this.tariffList[indexAddedId].topTutor.benefit = (applyDiscount && (discount > 0))?(discount):(benefit);
            this.tariffList[indexAddedId].topTutor.defaultBenefit = (response.stocks_next && (response.stocks_next.length > 0))?(nextPriceAll - item.price):(undefined);

            this.tariffList[indexAddedId].topTutor.costText = this.getStringCost(this.tariffList[indexAddedId].topTutor.cost);
            this.tariffList[indexAddedId].topTutor.oldCostText = this.getStringCost(item.price);
            this.tariffList[indexAddedId].topTutor.benefitText = this.getStringCost(
              (
                this.tariffList[indexAddedId].topTutor.benefit &&
                (this.tariffList[indexAddedId].topTutor.benefit > 0)
              )?(this.tariffList[indexAddedId].topTutor.benefit):(''));
          }
        }
      });

      if ((response.stocks.length > 0) && (Number(response.stocks[0].time_end) > 0)) {
        this.timer.timeEnd = Number(response.stocks[0].time_end); // время смены пакета в секундах

        let mskTime = new Date().toLocaleTimeString('ru-RU', { timeZone: 'Europe/Moscow' });
        let mskDate = new Date().toLocaleDateString('ru-RU', { timeZone: 'Europe/Moscow' });
        let mskTimeSplit = mskTime.split(':');  // 18:22:33
        let mskDateSplit = mskDate.split('.'); // 23.09.gk

        let mskSecondsTime = Number(new Date( mskDateSplit[2] + '-' + mskDateSplit[1] + '-' +  mskDateSplit[0] + 'T' + mskTimeSplit[0] + ':' + mskTimeSplit[1] + ':' + mskTimeSplit[2] + '+03:00').getTime())/1000;
        let timeLeft = this.timer.timeEnd - mskSecondsTime; // кол-во оставшегося времени в секундах

        if ((timeLeft > 0) && response.stocks_next && (response.stocks_next.length > 0)) {
          this.startTimer();
        }
      }

      if (this.$route.query.type === 'open_modal') {

        if ((this.$route.query.typeTutor !== undefined) && (this.$route.query.idTariff !== undefined)) {
          this.activeTariff = Number(this.$route.query.idTariff);
          this.activeTypeTutor = this.$route.query.typeTutor;
          this.paymentData.activeTypeTutor = this.$route.query.typeTutor;
          this.paymentData.idStock = Number(this.$route.query.idTariff);

          for (let i = 0; i < this.tariffList.length; i++) {
            if (this.tariffList[i].id === Number(this.$route.query.idTariff)) {
              this.paymentData.tariffName = this.tariffList[i].title;
              break;
            }
          }
        } else {
          this.activeTariff = response.stocks[0].type_id;
          this.paymentData.idStock = response.stocks[0].type_id;
          this.paymentData.tariffName = this.tariffList[0].title;
        }

        this.updateEndCost();
        this.openModalBuyCourse();
      } else if (sessionStorage.getItem('utmTariff')) {
        let dataUtm = JSON.parse(sessionStorage.getItem('utmTariff'));

        if (dataUtm.typeTutor === 'topTutor') {
          this.activeTypeTutor = 'topTutor';
        } else {
          this.activeTypeTutor = 'standardTutor';
        }

        if (dataUtm && dataUtm.idTariff) {
          this.activeTariff = Number(dataUtm.idTariff);
          this.paymentData.idStock = Number(dataUtm.idTariff);

          for (let i = 0; i < this.tariffList.length; i++) {
            if (this.tariffList[i].id === Number(dataUtm.idTariff)) {
              this.paymentData.tariffName = this.tariffList[i].title;
              break;
            }
          }
        } else {
          this.activeTariff = response.stocks[0].type_id;
          this.paymentData.idStock = response.stocks[0].type_id;
          this.paymentData.tariffName = this.tariffList[0].title;
        }

        sessionStorage.removeItem('utmTariff');
      } else {
        let idTariff = null;

        switch (typeData) {
          case 'gk':
            idTariff = response.stocks[0].type_id;
            break;

          case 'finalEssay':
            idTariff = response.stocks[0].id;
            break;
        }

        this.activeTariff = idTariff;
        this.paymentData.idStock = idTariff;
        this.paymentData.tariffName = this.tariffList[0].title;
      }
    },

    /** Установить данные по тарифам для новой страницы (нового функционала)
     * @param {Object} response - данные результата запроса
     * @param {Number} idCourse- id курса
     * @param {String} typeData - тип данных ГК / ПГК
     * */
    setNewTariffData(response, idCourse, typeData = 'gk') {
      let discount = this.bonusData.discount;
      let specialDiscount = this.paymentData.discountSpecialPromo ?? 0;

      this.listPrize = response.bonus_list;
      this.tariffList = response.stock_list.map((item, i) => {
        let listPackage = item.stocks.map((stock, j) => {
          let stockObj = {
            id: stock.stock_id,
            countLesson: stock.count_lessons,
            countLessonText: pluralize(stock.count_lessons, ['занятие', 'занятия', 'занятий']),
            countPrize: stock.bonus_list.length,
            countPrizeText: pluralize(stock.bonus_list.length, ['бонус', 'бонуса', 'бонусов']),
            prizeIds: stock.bonus_list,
            standardTutor: {
              enable: false,
              benefit: null,
              oldCost: null,
              costText: null,
              cost: null,
              idPrice: null,
              isAccessCredit: false, // доступна ли рассрочка
            },
            topTutor: {
              enable: false,
              benefit: null,
              oldCost: null,
              costText: null,
              cost: null,
              idPrice: null,
              isAccessCredit: false, // доступна ли рассрочка
            },
          }

          if (stock.prices.standard) {
            stockObj.standardTutor = {
              enable: true,
              benefit: discount + specialDiscount,
              oldCost: stock.prices.standard.price,
              costText: this.getStringCost(stock.prices.standard.price - discount - specialDiscount),
              cost: stock.prices.standard.price - discount - specialDiscount,
              idPrice: stock.prices.standard.price_id,
              isAccessCredit: stock.prices.standard.is_access_credit ?? false, // доступна ли рассрочка
            }
          }

          if (stock.prices.top) {
            stockObj.topTutor = {
              enable: true,
              benefit: discount + specialDiscount,
              oldCost: stock.prices.top.price,
              costText: this.getStringCost(stock.prices.top.price - discount - specialDiscount),
              cost: stock.prices.top.price - discount - specialDiscount,
              idPrice: stock.prices.top.price_id,
              isAccessCredit: stock.prices.top.is_access_credit ?? false, // доступна ли рассрочка
            }
          }

          return stockObj
        });

        return {
          id: item.id,
          title: item.name,
          description: item.description,
          enableSelectTeacher: item.is_select_teacher_type, // включен ли выбор репетитора
          listPackage: listPackage,
        }
      });

      if (this.$route.query.type === 'open_modal') {
        /** Получить index пакета по id
         * @param {Number} idStock - id элемента
         * @returns {Object}
         * */
        let getPackage = (idStock) => {
          for (let i = 0; i < this.listTariff.length; i++) {
            for (let j = 0; j < this.listTariff[i].listPackage.length; j++) {
              if (this.listTariff[i].listPackage[j].id === idStock) return {
                indexTariff: i,
                indexPackage: j,
              }
            }
          }

          return {
            indexTariff: null,
            indexPackage: null,
          };
        };

        if (
          (this.$route.query.typeTutor !== undefined) &&
          (this.$route.query.idTariff !== undefined)
        ) {
          let {indexTariff, indexPackage} = getPackage(Number(this.$route.query.idTariff));
          this.choiceTariff(this.tariffList[indexTariff].id, indexTariff);
          this.choicePackage(this.tariffList[indexTariff].listPackage[indexPackage], indexPackage);
        } else {
          this.activeTariff = response.stocks[0].stock_id;
          this.paymentData.idStock = response.stocks[0].stock_id;
          this.paymentData.tariffName = this.tariffList[0].title;
        }

        this.openModalBuyCourse();
      } else {
        this.choiceTariff(this.tariffList[0].id, 0);
        this.choicePackage(this.tariffList[0].listPackage[0], 0);
      }
    },

    // метод, устанавливающий данные для оплат для ГК и ОИ (работает с массивом с установкой типов репетиторов)
    setDataWithTypeTutors(response, idCourse, typeData = 'gk') {
      // response - данные от api
      // typeData - тип выгрузки / gk - ГК / finalEssay - итоговое сочинение

      switch (typeData) {
        case 'gk':
          this.typeCourse = 'gk';

          if ((response.is_buy_top !== undefined) && !response.is_buy_top ) {
            this.showSelectTutor = false;
            this.isBuyTop = false;
            this.activeTypeTutor = 'standardTutor';
          }

          if ((response.is_buy_standard !== undefined) && !response.is_buy_standard) {
            this.showSelectTutor = false;
            this.isBuyStandard = false;
            this.activeTypeTutor = 'topTutor';
          }
          break;

        case 'finalEssay':
          this.typeCourse = 'ff';
          this.showSelectTutor = false;
          this.activeTypeTutor = 'standardTutor';
          break;
      }

      this.oldTypeTutor = this.activeTypeTutor;
      this.paymentData.activeTypeTutor = this.activeTypeTutor;
      this.isOldVersion = response.is_old ?? true;
      this.paymentData.idCourse = idCourse;
      this.paymentData.idExam = response.exam?.type_id;
      this.dataReceived = true;

      this.setTimeBonus(response.bonus_timer);
      this.setAdditionalBonus(response.bonus_academy);

      if (this.isOldVersion) this.setOldTariffData(response, idCourse, typeData);
      else this.setNewTariffData(response, idCourse, typeData);

      // установить сумму для оплаты
      this.updateEndCost();
      this.managementUTMPromoCode();
      this.checkYandexPay();
    },

    /** Проверить проведение оплаты через Yandex Pay
    * */
    checkYandexPay() {
      // Успешная оплата
      let successfullyPay = (query) => {
        let getArrCourses = (idCourses) => {
          let splitCourses = idCourses.split('.');

          if (splitCourses) return splitCourses.map(item => {
            return {
              id: Number(item),
              idCourse: Number(item),
            }
          });

          return [];
        };

        setYandexMetric(getArrCourses(query.idCourses), Number(query.amount), 'yandex pay');
        this.modalBuyCourse.runSuccessfullyFunction = true;
        this.openModalBuyCourse();
      };

      // Не успешная оплата
      let errorPay = () => {
        this.openErrorModal('Оплата через Yandex Pay завершилась ошибкой');
      };

      const query = this.$route.query;
      if (!query.type || query.type !== 'oldPayYandex') return;
      if (query.payStatus === 'successfully') successfullyPay(query);
      else if (query.payStatus === 'error') errorPay();
      query.payStatus = 'none';
    },

    /** Проверяет значение на допустимость
     * @param {*} value - значение проверяемой переменной
     * @returns {Boolean}
    * */
    isValid(value) {
      return value !== null && value !== undefined
    },

    /** Очистить query в route
    * */
    clearQuery() {
      this.$router.replace({
        query: {}
      });
    },

    /** Устанавливает данные для дополнительного бонуса
     * @param {Array} bonusAcademy - спец. бонус
    * */
    setAdditionalBonus(bonusAcademy) {
      if (!bonusAcademy || !bonusAcademy.is_active) return;

      let isValidCourse = bonusAcademy.course_ids?.includes(Number(this.$route.params.idCourse));

      if (isValidCourse) {
        this.paymentData.specialPromo = bonusAcademy.promo;
        this.paymentData.discountSpecialPromo = bonusAcademy.sum;
      }
    },

    /** Устанавливает данные по скидке для бонуса ограниченного по времени (например скидка на покупку 2-го предмета)
    * */
    setTimeBonus(bonusTimer) {
      let isActive = bonusTimer && bonusTimer.is_active;
      let discount = (isActive && (bonusTimer.sum !== null))?(bonusTimer.sum):(0);
      this.bonusData.isActive = bonusTimer && bonusTimer.is_active;

      if (isActive) {
        this.benefitApplied = true;
        this.bonusData.discount = discount;
        this.bonusData.stockIds = bonusTimer.stock_ids;
        this.bonusData.promo = bonusTimer.promo;
        this.bonusData.timeEnd = bonusTimer.time_end;
        this.bonusData.text = `Доступна скидка в ${this.bonusData.discount} ₽ на покупку дополнительного предмета. Скидка действительна в течение 60 минут — потом она сгорит.`;
      } else {
        this.benefitApplied = false;
        this.bonusData.discount = 0;
        this.bonusData.stockIds = [];
        this.bonusData.promo = '';
        this.bonusData.timeEnd = 0;
        this.bonusData.text = '';
      }
    },

    startTimer() {
      let th = this;

      let mskTime = new Date().toLocaleTimeString('ru-RU', { timeZone: 'Europe/Moscow' });
      let mskDate = new Date().toLocaleDateString('ru-RU', { timeZone: 'Europe/Moscow' });
      let mskTimeSplit = mskTime.split(':');  // 18:22:33
      let mskDateSplit = mskDate.split('.'); // 23.09.gk

      let mskSecondsTime = Number(new Date( mskDateSplit[2] + '-' + mskDateSplit[1] + '-' +  mskDateSplit[0] + 'T' + mskTimeSplit[0] + ':' + mskTimeSplit[1] + ':' + mskTimeSplit[2] + '+03:00').getTime())/1000;

      let timeLeft = this.timer.timeEnd - mskSecondsTime; // кол-во оставшегося времени в секундах

      if (timeLeft > 0) {
        if (!this.showTimer) {
          this.showTimer = true;
        }

        let days = Math.floor(timeLeft/24/60/60);
        let hours = Math.floor(timeLeft/60/60) - (days * 24);
        let minutes = Math.floor(timeLeft/60) - (hours * 60 + days * 24 * 60);
        let seconds = timeLeft - (minutes * 60 + hours * 60 * 60 + days * 24 * 60 * 60);

        this.timer.days = (days < 10)?('0' + days):(days);
        this.timer.hours = (hours < 10)?('0' + hours):(hours);
        this.timer.minutes = (minutes < 10)?('0' + minutes):(minutes);
        this.timer.seconds = (seconds < 10)?('0' + seconds):(seconds);

        let interval = 1000; // ms
        let expected = Date.now() + interval;
        setTimeout(step, interval);

        function step() {
          let dt = Date.now() - expected; // the drift (positive for overshooting)
          if (dt > interval) {
            th.startTimer();
          } else {
            timeLeft--;

            days = Math.floor(timeLeft/24/60/60);
            hours = Math.floor(timeLeft/60/60) - (days * 24);
            minutes = Math.floor(timeLeft/60) - (hours * 60 + days * 24 * 60);
            seconds = timeLeft - (minutes * 60 + hours * 60 * 60 + days * 24 * 60 * 60);

            th.timer.seconds = (seconds < 10)?('0' + seconds):(seconds);

            if (Number(th.timer.seconds) === 59) {
              th.timer.days = (days < 10)?('0' + days):(days);
              th.timer.hours = (hours < 10)?('0' + hours):(hours);
              th.timer.minutes = (minutes < 10)?('0' + minutes):(minutes);
            }

            expected += interval;

            if (timeLeft > 0) {
              setTimeout(step, Math.max(0, interval - dt)); // take into account drift
            } else {
              th.showTimer = false;
              th.getData()
            }
          }
        }
      } else if (timeLeft <= 0) {
        this.showTimer = false;
        this.getData()
      }
    },

    // установить сумму для оплаты
    updateEndCost() {
      let getPriceData = (item) => {
        let price, idPrice;

        if (this.activeTypeTutor === 'topTutor') {
          price = item.topTutor.cost;
          idPrice = item.topTutor.idPrice;
        } else {
          price = item.standardTutor.cost;
          idPrice = item.standardTutor.idPrice;
        }

        return {
          price,
          idPrice
        }
      };

      let setPriceData = (item) => {
        const priceData = getPriceData(item);
        this.paymentData.price = priceData.price;
        this.paymentData.idPrice = priceData.idPrice;
        this.paymentData.priceText = this.getStringCost(priceData.price);
      };

      if (this.isOldVersion) {
        for (let item of this.tariffList) {
          if (item.id === this.activeTariff) {
            setPriceData(item);
            break;
          }
        }
      } else {
        for (let item of this.tariffList) {
          if (item.id === this.activeTariff) {
            for (let stock of item.listPackage) {
              if (stock.id === this.activePackage) {
                setPriceData(stock);
                break;
              }
            }
            break;
          }
        }
      }
    },

    /** Выбрать тариф
     * @param {Number} id - id тарифа
     * @param {Number} index - index тарифа
    * */
    choiceTariff(id, index) {
      this.activeTariff = id;
      this.paymentData.tariffName = this.tariffList[index].title;
      this.paymentData.enableSelectTeacher = this.tariffList[index].enableSelectTeacher;

      if (this.isOldVersion) {
        this.paymentData.idStock = id;
        this.updateEndCost();
      } else {
        this.managementSelectTutorSwitch();
      }
    },

    /** Выбрать пакет
     * @param {Object} item - объект выбираемого пакета
     * @param {Number} index - index пакета
     * */
    choicePackage(item, index) {
      this.activePackage = item.id;
      this.paymentData.idStock = item.id;
      this.paymentData.packageName = item.countLessonText;

      this.updateEndCost();
    },

    /** Выбрать тариф для ПГК
     * @param {Number} id - id выбираемого тарифа
     * */
    changeTariffPGK(id) {
      if (this.activeTariff !== id) {
        let tariffData = this.listTariffPGK.find(item => item.id === id);

        this.activeTariff = id;
        this.paymentData.idCourse = tariffData.courseId;
        this.paymentData.idStock = tariffData.id;
        this.paymentData.tariffName = tariffData.title;
        this.paymentData.isAccessCredit = tariffData.installmentAvailable;
        this.paymentData.countMonth = tariffData.countMonth;

        if ((this.typeHeaderPoint === 'sliced') && this.idsTariffWithSelectTutor.includes(id)) {
          setTimeout(() => {
            if ((this.typeHeaderPoint === 'sliced') && this.idsTariffWithSelectTutor.includes(id)) this.typeHeaderPoint = 'full';
          }, 200);

          this.keyRate++;
        } else if ((this.typeHeaderPoint === 'full') && !this.idsTariffWithSelectTutor.includes(id)) {

          setTimeout(() => {
            if ((this.typeHeaderPoint === 'full') && !this.idsTariffWithSelectTutor.includes(id)) this.typeHeaderPoint = 'sliced';
          }, 200);

          this.keyRate++;
        }
      }

      this.updateEndCostPGK();
    },

    /** Установить сумму для оплаты для ПГК
     * */
    updateEndCostPGK() {
      for (let item of this.listTariffPGK) {
        if (
          (item.id === this.activeTariff) &&
          (
            (this.isFirstSwitchActive && (item.countMonth === 1)) ||
            (!this.isFirstSwitchActive && (item.countMonth !== 1))
          )
        ) {
          this.paymentData.price = item.cost
          this.paymentData.priceText = this.getStringCost(this.paymentData.price);

          break;
        }
      }
    },

    // применить промокод
    applyPromoCode(disabledError = false) {
      if (!this.promoCodeApplied && (this.promoCode.length > 0)) {
        switch (this.getTypeProduct()) {
          case 'ff': // Огненное итоговое
            this.applyPromoCodeFF(disabledError);
            break;

          case 'pgk': // ПГК
            this.applyPromoCodePGK(disabledError);
            break;

          default: // ГК
            this.applyPromoCodeGK(disabledError);
        }
      }
    },

    /** применить промокод для ПГК
     * @param {Boolean} disabledError - выключено ли сообщение об ошибке
    * */
    applyPromoCodePGK(disabledError = false) {
      let data = {
        module: 'check_promo',
        promo: this.promoCode,
        course_id: this.$route.params.idCourse,
      };

      console.log('check_promo');
      console.log(data);

      send
        .post("semi_course.php", data)
        .then((response) => {
          console.log('get_stock');
          console.log(response);

          this.paymentData.promoCode = this.promoCode;
          this.paymentData.idTariffPromoCode = response.promo.stock_id;
          this.paymentData.timeEndPromoCode = (response.promo.time_end)?(response.promo.time_end):(undefined);
          this.paymentData.pricesTop = null;
          this.paymentData.pricesStandard = null;
          this.paymentData.teacherType = -1; // -1 - не зависит от типа / 0 - только для стандарт / 1 - только для топ
          this.paymentData.prices = response.promo.prices;

          this.notification.show = true;
          this.notification.text = 'Промокод применен!';
          this.notification.type = 'successfully';
          this.promoCodeApplied = true;

          if (this.paymentData.prices && (Object.keys(this.paymentData.prices).length > 0)) {
            this.listTariffPGK.forEach((item, i) => {
              if (this.paymentData.prices.hasOwnProperty(item.id)) {
                this.setDiscountData('pgk', 0, this.paymentData.prices[item.id], i);
              }
            })
          } else if (Array.isArray(this.paymentData.idTariffPromoCode)) { // получен массив id тарифов для скидки
            this.listTariffPGK.forEach((item, i) => {
              if (this.paymentData.idTariffPromoCode.includes(item.id)) {
                this.setDiscountData('pgk', 0, response.promo.sum, i);
              }
            })
          } else if (this.paymentData.idTariffPromoCode === -1) {
            this.listTariffPGK.forEach((item, i) => {
              this.setDiscountData('pgk', 0, response.promo.sum, i);
            })
          } else {
            for (let i = 0; i < this.tariffList.length; i++) {
              if (this.listTariffPGK[i].id === response.promo.stock_id) {
                this.setDiscountData('pgk', 0, response.promo.sum, i);
                break;
              }
            }
          }

          this.updateEndCostPGK();
        })
        .catch((error) => {
          console.log('error check_promo');
          console.log(error.response);
          console.log(error)

          this.promoErrorHandling(error.response.data, disabledError);
        });
    },

    /** применить промокод для огненного итогового сочинения
     * @param {Boolean} disabledError - выключено ли сообщение об ошибке
    * */
    applyPromoCodeFF(disabledError = false) {
      let data = {
        module: 'check_promo',
        promo: this.promoCode,
        course_id: this.$route.params.idCourse,
      };

      console.log('check_promo');
      console.log(data);

      send
        .post("final_essay.php", data)
        .then((response) => {
          console.log('get_stock');
          console.log(response);

          this.paymentData.promoCode = this.promoCode;
          this.paymentData.idTariffPromoCode = response.promo.stock_id;
          this.paymentData.timeEndPromoCode = (response.promo.time_end)?(response.promo.time_end):(undefined);
          this.paymentData.pricesTop = null;
          this.paymentData.pricesStandard = null;
          this.paymentData.teacherType = -1; // -1 - не зависит от типа / 0 - только для стандарт / 1 - только для топ
          this.paymentData.prices = response.promo.prices;

          this.notification.show = true;
          this.notification.text = 'Промокод применен!';
          this.notification.type = 'successfully';
          this.promoCodeApplied = true;

          if (this.paymentData.idTariffPromoCode === -1) {
            this.tariffList.forEach((item, i) => {
              this.setDiscountData('finalEssay', 0, response.promo.sum, i);
            })
          } else if (this.paymentData.prices && (Object.keys(this.paymentData.prices).length > 0)) {
            this.tariffList.forEach((item, i) => {
              if (this.paymentData.prices.hasOwnProperty(item.id)) {
                this.setDiscountData('finalEssay', 0, this.paymentData.prices[item.id], i);
              }
            })
          } else if (Array.isArray(this.paymentData.idTariffPromoCode)) { // получен массив id тарифов для скидки
            this.tariffList.forEach((item, i) => {
              if (this.paymentData.idTariffPromoCode.includes(item.id)) {
                this.setDiscountData('finalEssay', 0, response.promo.sum, i);
              }
            })
          } else {
            for (let i = 0; i < this.tariffList.length; i++) {
              if (this.tariffList[i].id === response.promo.stock_id) {
                this.setDiscountData('finalEssay', 0, response.promo.sum, i);
                break;
              }
            }
          }

          this.updateEndCost();
        })
        .catch((error) => {
          console.log('error check_promo');
          console.log(error.response);
          console.log(error)

          this.promoErrorHandling(error.response.data, disabledError);
        });
    },

    /** применить промокод ГК
     * @param {Boolean} disabledError - выключено ли сообщение об ошибке
    * */
    applyPromoCodeGK(disabledError = false) {
      let data = {
        module: 'check_promo',
        promo: this.promoCode,
        course_id: this.$route.params.idCourse,
      };

      console.log('check_promo');
      console.log(data);

      send
        .post("course.php", data)
        .then((response) => {
          console.log('check_promo');
          console.log(response);

          let teacherType = response.promo.teacher_type; // -1 - все / 0 - стандарт / 1 - топ
          this.paymentData.promoCode = this.promoCode;
          this.paymentData.idTariffPromoCode = response.promo.stock_id;
          this.paymentData.timeEndPromoCode = (response.promo.time_end)?(response.promo.time_end):(undefined);
          this.paymentData.pricesTop = response.promo.pricesTop;
          this.paymentData.pricesStandard = response.promo.pricesStandard;
          this.paymentData.teacherType = response.promo.teacher_type; // -1 - не зависит от типа / 0 - только для стандарт / 1 - только для топ

          this.notification.show = true;
          this.notification.text = 'Промокод применен!';
          this.notification.type = 'successfully';
          this.promoCodeApplied = true;

          if (response.promo.sum === null) {
            
            /** Установить скидку 
             * @param {Number} stockId - id тарифа
             * @param {Number} standardTutorOldCost - стоимость стандартного репетитора 
             * @param {Number} topTutorOldCost - стоимость топ репетитора
             * @param {Number} i - индекс тарифа 
             * @param {Number} j - индекс пакета
             * */
            let setDiscount = (stockId, standardTutorOldCost, topTutorOldCost, i, j = null) => {
              let promoSumStandard = undefined;
              let promoSumTop = undefined;

              if (
                (this.paymentData.pricesStandard[stockId] !== undefined) &&
                (standardTutorOldCost > this.paymentData.pricesStandard[stockId])
              ) {
                promoSumStandard = this.paymentData.pricesStandard[stockId];
              }

              if (
                (this.paymentData.pricesTop[stockId] !== undefined) &&
                (topTutorOldCost > this.paymentData.pricesTop[stockId])
              ) {
                promoSumTop = this.paymentData.pricesTop[stockId];
              }

              if ((promoSumStandard !== undefined) || (promoSumTop !== undefined)) this.setDiscountData(
                'gk', 
                teacherType, 
                response.promo.sum, 
                i,
                j, 
                {
                  promoSumStandard: promoSumStandard,
                  promoSumTop: promoSumTop,
                }
              );
            };
            
            if (this.isOldVersion) {
              this.tariffList.forEach((item, i) => {
                setDiscount(
                  item.id,
                  item.standardTutor.oldCost,
                  item.topTutor.oldCost,
                  i,
                );
              })  
            } else {
              this.tariffList.forEach((item, i) => {
                item.listPackage.forEach((stock, j) => {
                  setDiscount(
                    stock.id,
                    stock.standardTutor.oldCost,
                    stock.topTutor.oldCost,
                    i,
                    j,
                  );
                });
              });
            }
            
          } else if (Array.isArray(this.paymentData.idTariffPromoCode)) { // получен массив id тарифов для скидки
            if (this.isOldVersion) {
              this.tariffList.forEach((item, i) => {
                if (this.paymentData.idTariffPromoCode.includes(item.id)) {
                  this.setDiscountData('gk', teacherType, response.promo.sum, i);
                }
              });
            } else {
              this.tariffList.forEach((item, i) => {
                item.listPackage.forEach((stock, j) => {
                  if (this.paymentData.idTariffPromoCode.includes(stock.id)) {
                    this.setDiscountData('gk', teacherType, response.promo.sum, i, j);
                  }
                });
              });
            }
          } else if (response.promo.stock_id === -1) {
            if (this.isOldVersion) {
              this.tariffList.forEach((item, i) => {
                this.setDiscountData('gk', teacherType, response.promo.sum, i);
              })
            } else {
              this.tariffList.forEach((item, i) => {
                item.listPackage.forEach((stock, j) => {
                  this.setDiscountData('gk', teacherType, response.promo.sum, i, j);
                });
              });
            }
          } else {
            if (this.isOldVersion) {
              for (let i = 0; i < this.tariffList.length; i++) {
                if (this.tariffList[i].id === response.promo.stock_id) {
                  this.setDiscountData('gk', teacherType, response.promo.sum, i);
                  break;
                }
              }
            } else {
              let isBreak = false;
              
              for (let i = 0; i < this.tariffList.length; i++) {
                for (let j = 0; j < this.tariffList[i].listPackage.length; j++) {
                  if (this.tariffList[i].listPackage[j].id === response.promo.stock_id) {
                    isBreak = true;
                    this.setDiscountData('gk', teacherType, response.promo.sum, i, j);
                    break;
                  }
                }
                
                if (isBreak) break;
              }
            }
          }

          this.updateEndCost();
        })
        .catch((error) => {
          console.log('error check_promo');
          console.log(error.response);
          console.log(error)

          this.promoErrorHandling(error.response.data, disabledError);
        });
    },

    /** Обработка ошибок при невалидном промокоде
     * @param {Object} data - данные по ошибке
     * @param {Boolean} disabledError - выключено ли отображение об ошибке
    * */
    promoErrorHandling(data, disabledError = false) {
      if (
        (data.error === "error_fields") &&
        (data.error_field.includes('promo'))
      ) {
        if (!disabledError) this.openErrorModal('Введенный промокод неверен!');
        this.promoCode = '';
      }
    },

    /** Открыть модальное окно с успехом
     * @param {String} text - текст модального окна
     * */
    openSuccessfullyModal(text) {
      emitter.emit('openGlobalNotifications', {
        show: true,
        time: 4,
        text: text,
        type: 'successfully'
      });
    },

    /** Открыть модальное окно с ошибкой
     * @param {String} text - текст ошибки
     * */
    openErrorModal(text) {
      emitter.emit('openGlobalNotifications', {
        show: true,
        time: 4,
        text: text,
        type: 'error'
      });
    },

    // устанавливает скидку для определенного тарифа
    setDiscountData(type, teacherType, promoSum, i, j, objPrices = undefined) {
      switch (type) {
        case 'pgk': // ПГК
          this.listTariffPGK[i].cost = this.listTariffPGK[i].oldCost - promoSum;
          this.listTariffPGK[i].costString = this.getStringCost(this.listTariffPGK[i].oldCost - promoSum);
          this.listTariffPGK[i].saleBenefit = promoSum + (this.listTariffPGK[i].benefit ?? 0);
          this.listTariffPGK[i].saleBenefitString = this.getStringCost(promoSum + (this.listTariffPGK[i].benefit ?? 0));
          break;

        default: // Остальные
          let promoSumStandard, promoSumTop;
          let tariffEl = (this.isOldVersion)?(this.tariffList[i]):(this.tariffList[i].listPackage[j]);
          let specialDiscount = this.paymentData.discountSpecialPromo ?? 0;

          if (objPrices === undefined) {
            promoSumStandard = promoSum + specialDiscount;
            promoSumTop = promoSum + specialDiscount;
          } else {
            promoSumStandard = tariffEl.standardTutor.oldCost - objPrices.promoSumStandard - specialDiscount;
            if (type === 'gk') promoSumTop = tariffEl.topTutor.oldCost - objPrices.promoSumTop - specialDiscount;
          }

          if ((promoSumStandard !== undefined) && ((teacherType === -1) || (teacherType === 0))) {
            tariffEl.standardTutor.cost = tariffEl.standardTutor.oldCost - promoSumStandard;
            tariffEl.standardTutor.benefit = promoSumStandard;
            tariffEl.standardTutor.costText = this.getStringCost(tariffEl.standardTutor.oldCost - promoSumStandard);
            tariffEl.standardTutor.benefitText = this.getStringCost(promoSumStandard);
          }

          if ((type === 'gk') && (promoSumTop !== undefined) && ((teacherType === -1) || (teacherType === 1))) {
            tariffEl.topTutor.cost = tariffEl.topTutor.oldCost - promoSumTop;
            tariffEl.topTutor.benefit = promoSumTop;
            tariffEl.topTutor.benefitText = String(promoSumTop);
            tariffEl.topTutor.costText = this.getStringCost(tariffEl.topTutor.oldCost - promoSumTop);
          }
      }
    },

    // удалить промокод
    removePromoCode() {
      this.promoCodeApplied = false;
      this.promoCode = '';
      // window.sessionStorage.removeItem("promoCode");

      this.paymentData.promoCode = null;
      this.paymentData.idTariffPromoCode = undefined;
      this.paymentData.timeEndPromoCode = undefined;
      this.paymentData.pricesTop = null;
      this.paymentData.pricesStandard = null;
      this.paymentData.prices = undefined;

      /** Устанавливает стоимость и размер скидки для пакета
      * */
      let setCostAndBenefitPackage = (item, applyDiscount) => {
        let specialDiscount = this.paymentData.discountSpecialPromo ?? 0;

        if (applyDiscount) {
          item.cost = item.oldCost - this.bonusData.discount - specialDiscount;
          item.benefit = this.bonusData.discount + specialDiscount;
        } else {
          item.cost = item.oldCost - specialDiscount;
          item.benefit = item.defaultBenefit + specialDiscount;
        }

        item.costText = this.getStringCost(item.cost);
        item.benefitText = this.getStringCost(item.benefit ?? '');
      };

      /** Скидка была применена
       * @param {Number} id - id пакета
       * @returns {Boolean} пременен ли промокод
      * */
      let discountApplied = (id) => {
        return this.benefitApplied && ((this.bonusData.stockIds === -1) || (this.bonusData.stockIds.includes(id)));
      };

      console.log('работает промо удален');
      console.log('this.productName', this.productName);

      switch (this.productName) {
        case 'pgk':
          this.listTariffPGK.forEach((item, i) => {
            item.cost = item.oldCost;
            item.costString = item.oldCostString;
            item.saleBenefit = item.benefit;
            item.saleBenefitString = item.benefitString;
          });

          this.updateEndCostPGK();
          break;

        default:
          if (this.isOldVersion) {
            this.tariffList.forEach((tariff, k) => {
              tariff.standardTutor.cost = tariff.standardTutor.oldCost;
              tariff.standardTutor.benefit = tariff.standardTutor.defaultBenefit;
              tariff.standardTutor.costText = tariff.standardTutor.oldCostText;

              tariff.topTutor.cost = tariff.topTutor.oldCost;
              tariff.topTutor.benefit = tariff.topTutor.defaultBenefit;
              tariff.topTutor.costText = tariff.topTutor.oldCostText;
            });
          } else {
            this.tariffList.forEach((tariff, k) => {
              tariff.listPackage.forEach((item, i) => {
                let applyDiscount = discountApplied(item.id)

                setCostAndBenefitPackage(item.standardTutor, applyDiscount);
                setCostAndBenefitPackage(item.topTutor, applyDiscount);
              });
            });

          }

          this.updateEndCost();
      }
    },

    // установить тип репетитора
    setTutor(type) {
      this.paymentData.activeTypeTutor = type;
      this.updateEndCost();
    },

    // закрыть окно уведомлений
    closeModalNotification() {
      this.notification.show = false;
    },

    /** Возвращает тип продукта по id
     * @returns {String} тип продукта
     * */
    getTypeProduct() {
      const course = this.$store.state.allCourses[this.$route.params.idCourse];
      if (course && course.type) return course.type
      return undefined
    },

    /** Преднастройка данных по рассрочке
     * @param {(String|Number)} idOrder - id заказа
     * @returns {Promise}
     * */
    getInstallmentId(idOrder) {
      return new Promise((resolve, reject) => {
        send
          .post('unregistered.php', {
            module: 'get_payment_tinkoff_installment',
            order_id: idOrder,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },

    /** Открыть модальное окно оплаты курса
    * */
    openModalBuyCourse() {
      // Вернуть список доступных рассрочек в виде массива
      let getInstallmentList = (installmentInfo, amount) => {
        if (!installmentInfo) return [];

        let installmentList = installmentInfo.map((item, i) => {
          let sumPay = Math.floor(amount / item.term);

          return {
            id: item.id,
            term: item.term,
            termText: pluralize(item.term, ['месяц', 'месяца', 'месяцев']),
            sumPay: sumPay, // сумма ежемесячной оплаты
            sumPayString: String(sumPay).split(/(?=(?:...)*$)/).join(' '),
            promo: item.promo,
          };
        });

        return installmentList.sort((prev, next) => prev.term - next.term);
      }

      // Установить id рассрочки Тинькофф
      let setInstallmentId = (idOrder) => {
        this.getInstallmentId(idOrder).then(response => {
          this.installmentData.orderId = response.installment_id;
          this.installmentData.amount = response.amount;
        });
      };

      // Установить данные для рассрочки
      let setInstallmentData = (keys, amount, idOrder) => {
        setInstallmentId(idOrder);
        this.installmentData.showcaseId = keys.gk.tinkoff.showcaseId;
        this.installmentData.shopId = keys.gk.tinkoff.shopId;
        this.installmentData.list = getInstallmentList(keys.credit_info.gk, amount);
        this.installmentData.max = this.installmentData.list.length;
      };

      switch (this.getTypeProduct()) {
        case 'pgk': // ПГК
          this.paymentData.type = 'pgk';
          break;

        default: // ГК
          if (this.bonusData.isActive && !this.promoCodeApplied) {
            this.paymentData.promoCode = this.bonusData.promo;
            this.paymentData.idTariffPromoCode = this.bonusData.stockIds;
            this.paymentData.timeEndPromoCode = this.bonusData.timeEnd;
          }

          for (let i = 0; i < this.tariffList.length; i++) {
            if (this.tariffList[i].id === this.activeTariff) {
              if (this.isOldVersion) {
                switch (this.activeTypeTutor) {
                  case 'standardTutor':
                    this.paymentData.isAccessCredit = this.tariffList[i].standardTutor.isAccessCredit;
                    break;

                  case 'topTutor':
                    this.paymentData.isAccessCredit = this.tariffList[i].topTutor.isAccessCredit;
                    break;
                }
              } else {
                for (let j = 0; j < this.tariffList[i].listPackage.length; j++) {
                  if (this.tariffList[i].listPackage[j].id === this.activePackage) {
                    switch (this.activeTypeTutor) {
                      case 'standardTutor':
                        this.paymentData.isAccessCredit = this.tariffList[i].listPackage[j].standardTutor.isAccessCredit;
                        break;

                      case 'topTutor':
                        this.paymentData.isAccessCredit = this.tariffList[i].listPackage[j].topTutor.isAccessCredit;
                        break;
                    }

                    break;
                  }
                }
              }

              break;
            }
          }
      }

      this.paymentData.idOrder = null;

      let timeoutOrder = setTimeout(() => {
        this.visibleWaitingComponent(true);
      }, 500);

      // Данные заказа успешно получены
      let successfullyCreateOrder = (response) => {
        clearTimeout(timeoutOrder);
        if (this.showModalWaitingQuery) this.visibleWaitingComponent(false);
        this.paymentData.idOrder = response.order_id;
        this.modalBuyCourse.show = true;
        setInstallmentData(response.keys, response.amount, response.order_id);
      };

      // При формировании данных заказа произошла ошибка
      let failCreateOrder = (error) => {
        console.log('При формировании данных заказа произошла ошибка', error);
        console.log(error.response);

        if (error.response?.data.error) {
          clearTimeout(timeoutOrder);
          if (this.showModalWaitingQuery) this.visibleWaitingComponent(false);
          this.modalBuyCourse.show = true;
        }
      }

      this.createOrder(this.paymentData.idPrice).then(
        response => successfullyCreateOrder(response),
        error => failCreateOrder(error),
      )
    },

    /** Создает заказ
     * @param {Number, String} idPay - id цены курса, который пользователь добавляет в корзину
     * @returns {Promise} ответ от апи с данными о добавленном товаре
     * */
    createOrder(idPay) {
      let utmMark = (localStorage.getItem('utmMark')) ? JSON.parse(localStorage.getItem('utmMark')) : null;
      let utmAmoCrm = (sessionStorage.getItem('utmAmoCrm')) ? JSON.parse(sessionStorage.getItem('utmAmoCrm')) : null;
      let promoList = this.paymentData.promoCode ? [this.paymentData.promoCode] : null;

      return new Promise((resolve, reject) => {
        send
          .post('payments_v2.php', {
            module: 'add_course_in_order',
            price_id: idPay,
            utm: utmMark,
            utm_amo: utmAmoCrm,
            promo_list: promoList,
            is_get_keys: true,
            is_cart: false,
            is_info: false,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },

    closeModalBuyCourse(data){
      if (this.modalBuyCourse.show) {
        this.modalBuyCourse.show = false
      }

      if (data === 'promocode_time_end') { // промокод просрочен
        this.removePromoCode();
      }
    },

    // закрыть компонент с информацией о скидке
    closeDiscountComponent() {
      this.bonusData.isActive = false;
      this.bonusData.text = '';
      this.bonusData.discount = 0;
      this.bonusData.stockIds = [];
      this.bonusData.promo = '';
      this.bonusData.timeEnd = 0;

      if (this.isOldVersion) {
        this.tariffList.forEach((item, i) => {
          // top tutor - удаление информации о скидки
          this.tariffList[i].topTutor.cost = this.tariffList[i].topTutor.oldCost;
          this.tariffList[i].topTutor.benefit = this.tariffList[i].topTutor.defaultBenefit;
          this.tariffList[i].topTutor.costText = this.tariffList[i].topTutor.oldCostText;

          this.tariffList[i].topTutor.benefitText = this.getStringCost(
            (
              this.tariffList[i].topTutor.benefit &&
              (this.tariffList[i].topTutor.benefit > 0)
            )?(this.tariffList[i].topTutor.benefit):(''));

          // standard tutor - удаление информации о скидки
          this.tariffList[i].standardTutor.cost = this.tariffList[i].standardTutor.oldCost;
          this.tariffList[i].standardTutor.benefit = this.tariffList[i].standardTutor.defaultBenefit;
          this.tariffList[i].standardTutor.costText = this.tariffList[i].standardTutor.oldCostText;

          this.tariffList[i].standardTutor.benefitText = this.getStringCost(
            (this.tariffList[i].standardTutor.benefit &&
              (this.tariffList[i].standardTutor.benefit > 0)
            )?(this.tariffList[i].standardTutor.benefit):('')
          );
        });
      } else {
        this.tariffList.forEach((item, i) => {
          item.listPackage.forEach((stock, j) => {
            stock.standardTutor.benefit = 0;
            stock.standardTutor.costText = this.getStringCost(stock.standardTutor.oldCost);
            stock.standardTutor.cost = stock.standardTutor.oldCost;
            stock.topTutor.benefit = 0;
            stock.topTutor.costText = this.getStringCost(stock.standardTutor.oldCost);
            stock.topTutor.cost = stock.standardTutor.oldCost;
          });
        });
      }

      this.updateEndCost();
    },

    /** Возвращает объект искомого тарифа
     * @param {Array} tariffs - список тарифов
     * @param {String} title - наименование тарифа
     * @param {Number} countMonth - кол-во месяцев
     * @returns объект тарифа
     * */
    getTariffData(tariffs, title, countMonth) {
      for (let i = 0; i < tariffs.length; i++) {
        if ((tariffs[i].title === title) && (tariffs[i].countMonth === countMonth)) {
          return tariffs[i]
        }
      }

      return undefined
    },

    // возвращает index активного тарифа
    getIndexActiveTariff(tariffs) {
      for (let i = 0; i < tariffs.length; i++) {
        if (tariffs[i].id === this.activeTariff) {
          return i
        }
      }

      return null;
    },

    /** Устанавливает активный тариф
     * */
    setActiveTariff() {
      if (this.listTariffPGK.length > 0) {
        let indexTariff = 0;

        if (this.activeTariff !== undefined) indexTariff = this.getIndexActiveTariff(this.listTariffPGK);

        const tariffData = this.getTariffData(
          this.listTariffPGK,
          this.listTariffPGK[indexTariff].title,
          (this.isFirstSwitchActive)?(this.pgkCountMonth.min):(this.pgkCountMonth.max)
        )

        this.activeTariff = tariffData.id;
        this.paymentData.idCourse = tariffData.courseId;
        this.paymentData.idStock = tariffData.id;
        this.paymentData.tariffName = tariffData.title;
        this.paymentData.isAccessCredit = tariffData.installmentAvailable;
        this.paymentData.countMonth = tariffData.countMonth;

        if ((this.typeHeaderPoint === 'sliced') && this.idsTariffWithSelectTutor.includes(tariffData.id)) this.typeHeaderPoint = 'full';
        else if ((this.typeHeaderPoint === 'full') && !this.idsTariffWithSelectTutor.includes(tariffData.id)) this.typeHeaderPoint = 'sliced';

        this.updateEndCostPGK();
      }
    },

    /** Сменить позицию switch
     * @param {Boolean} value - значение переключателя месяцев
    * */
    changeSwitchPGK(value) {
      this.isFirstSwitchActive = value;
      this.setActiveTariff();
    },

    /** Управление функционалом выбора репетитора и настройка предварительного выбора
     * */
    managementSelectTutorSwitch() {
      if (!this.isBuyTop || !this.isBuyStandard) return;

      let indexActiveTariff = this.getIndexActiveTariff(this.tariffList);
      let activeTariff = this.tariffList[indexActiveTariff];

      if (activeTariff.enableSelectTeacher) {
        if (!this.showSelectTutor) {
          this.showSelectTutor = true;
          this.activeTypeTutor = this.oldTypeTutor;
          this.setTutor(this.activeTypeTutor);
        }
      } else {
        this.oldTypeTutor = this.activeTypeTutor;
        this.activeTypeTutor = 'standardTutor';
        this.setTutor(this.activeTypeTutor);
        this.showSelectTutor = false;
      }
    },
  },

  computed: {
    // управляет значением switch "сейчас выбран топ репетитор?"
    topTutorValue: {
      get() {
        return this.activeTypeTutor === 'topTutor'
      },
      set(modelValue) {
        if (value) {
          this.activeTypeTutor = 'topTutor';
          this.paymentData.activeTypeTutor = 'topTutor';
        } else {
          this.activeTypeTutor = 'standardTutor';
          this.paymentData.activeTypeTutor = 'standardTutor';
        }
      }
    },

    // получить наименование пути для перехода после оплаты
    getNextRouteModalBuyCourse() {
      if ((this.typeHeaderPoint === 'sliced') && (this.typeCourse === 'gk')) return 'FillingProfile';
      return null;
    },
  },

  components: {
    ModalNotification,
    Swiper,
    SwiperSlide,
    HeaderPoint,
    CheckBar,
    WaitingLoading,
    ModalBuyCourse,
    OfferToBuyComponent,
    MobileStepInfo,
    BlockInfoCredit,
    DefaultSelectTariff,
    PGKSelectTariff,
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../style/styles_fonts";

$font_Geometria: Geometria, 'Geometria';

$color_background: #F6F6FB;
$color_Gray_1: #C5C5C9;
$color_Gray_2: #ABABB2;
$color_Gray_3: #8D909F;
$color_Gray_4: #EBEBEB;
$color_Gray_5: #F2F2F2;
$color_Gray_6: #F9F9F9;
$color_black: #333333;
$color_purple: #8C71FE;
$color_purple_2: #F2F1FF;
$color_purple_3: #E2E2F6;
$color_purple_4: #7B61EB;
$color_purple_5: #6F57D6;
$color_purple_6: #B1A1F2;
$color_red: #FF6597;
$color_green: #89CE54;
$color_grey: #AEBCD6;
$color_cyan: #C0CADC;
$color_cyan_2: #AEBCD6;
$color_cyan_3: #D1DBED;

$color_whiteHover: #fafafa;

$transition_medium: 0.5s ease;
$transition_fast: 0.25s ease;

$path_img_checkbox: '/lk/gk/img/check.svg';

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}
.fade-enter-from, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.fadeFast-enter-active, .fadeFast-leave-active {
  transition: opacity .25s ease-in;
}
.fadeFast-enter-from, .fadeFast-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.fadeBackground-enter-active, .fadeBackground-leave-active {
  transition: opacity .25s ease;
}
.fadeBackground-enter-from, .fadeBackground-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.block {
  display: flex;
}

.block__row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.block__column {
  display: flex;
  flex-direction: column;
}

.tariff_component .block__theme_mobile-steps {
  display: none;
}

.tariff_component .block_promocode__desktop {
  display: flex;
}

.tariff_component .block_promocode__tablet {
  display: none;
}

.tariff_component .block_promocode__mobile {
  display: none;
}

.tariff_component .block_timer__desktop {
  display: flex;
}

.tariff_component .block_timer__mobile_tablet {
  display: none;
}

.block_column {
  display: flex;
  flex-direction: column;
}

.block_row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.select-tariff-component {
  margin-top: 28px;
}

.item_svg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.item_title {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;
  transition: $transition_medium;
}

// блок с промокодом
.sidebar_header {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: $color_cyan_2;
  text-transform: uppercase;
  margin: 16px 24px 14px 24px;
}

.sidebar_border {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.08);
}

.sidebar_item {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  margin-top: 28px;
}

.block_promo {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: flex-start;
  grid-gap: 12px;
  margin: 20px 24px;
}

.promo_input {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  height: 54px;
  padding: 0 20px;
  width: calc(100% - 40px);
  transition: $transition_medium;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: $color_black;
  font-family: $font-Geometria;
  outline: none;

  &:hover {
    border-color: $color_Gray_2;
  }

  &:focus {
    border-color: $color_purple;
  }
}

.promo_input:disabled:hover {
  border-color: rgba(0, 0, 0, 0.08);
}

.button__type_remove {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: $color_red;
  cursor: pointer;
  position: absolute;
  right: 12px;
  transition: $transition_medium;

  svg {
    width: 10px;
    height: 10px;
  }

  &:hover {
    background-color: #FF6597;
  }
}

.promo_button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: default;
  width: 56px;
  height: 56px;
  border-radius: 8px;
  transition: $transition_medium;
  background-color: $color_purple_2;
}

.promo_svg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  svg path {
    fill: $color_purple;
    stroke: $color_purple;
    transition: $transition_medium;
  }
}

.promo_button__active {
  background-color: $color_purple;
  cursor: pointer;

  &:hover {
    background-color: $color_purple_4;
  }

  .promo_svg {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    svg path {
      fill: white;
      stroke: white;
    }
  }
}

.promo_button__applied {
  background-color: $color_green;
  cursor: default;

  svg path {
    stroke: white;
    fill: white;
  }
}

.promo_input::placeholder {
  font-family: $font-Geometria;
}


// чекбокс с пользовательским соглашением
.agreement {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  margin-top: 28px;
  cursor: pointer;
  transition: $transition_medium;


  .checkbox__active {
    border-color: $color_purple;

    .checkbox_text {
      color: $color_purple;
    }
  }

  .checkbox_text {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
  }

  .question_checkbox {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }

  .question_checkbox+span {
    display: inline-flex;
    align-items: center;
    user-select: none;
  }
  .question_checkbox+span::before {
    content: '';
    display: inline-block;
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    flex-shrink: 0;
    opacity: 1;
    flex-grow: 0;
    border: 2px solid rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 70% 70%;
    transition: $transition_fast;
  }

  .question_checkbox:checked+span::before {
    border-color: $color_purple;
    background-color: $color_purple;
    background-image: url($path_img_checkbox);
  }

  .text_label {
    margin-left: 8px;

    a {
      color: $color_purple;
      transition: $transition_medium;
      cursor: pointer;

      &:hover {
        color: $color_purple_4;
      }
    }
  }
}

// блок с таймером
.timer_row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: flex-start;
  grid-gap: 10px;
  margin: 20px 24px 15px 24px;
}

.timer_item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.timer_meaning {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 68px;
  cursor: default;
  font-weight: 500;
  font-size: 24px;
  line-height: 30px;
  color: $color_purple;
  background: $color_purple_2;
  border-radius: 8px;
}

.timer_clarification {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: $color_cyan_2;
  text-align: center;
  margin-top: 4px;
}

.timer_dots {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 68px;
}

.timer_dot {
  background-color: $color_cyan_2;
  width: 4px;
  height: 4px;
  border-radius: 50%;
}

.timer_dot:not(:last-child) {
  margin-bottom: 6px;
}

@media all and (max-width: 1700px) {
  .item_title {
    font-size: 17px;
    line-height: 21px;
  }

  .item_svg svg {
    width: 32px;
    height: 32px;
  }
}

@media all and (max-width: 1600px) {
  .select-tariff-component {
    margin-top: 24px;
  }

  .promo_input {
    height: 50px;
    padding: 0 18px;
    font-size: 15px;
    line-height: 19px;
  }

  .promo_button {
    width: 52px;
    height: 52px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  // блок с промокодом
  .sidebar_item {
    margin-top: 24px;
  }

  .sidebar_header {
    font-size: 13px;
    line-height: 17px;
    margin: 16px 22px 12px 22px;
  }

  .promo_input {
    height: 50px;
    padding: 0 18px;
    width: calc(100% - 36px);
    font-size: 15px;
    line-height: 19px;
  }

  .promo_button {
    width: 52px;
    height: 52px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  .block_promo {
    margin: 18px 22px;
  }

  .agreement {
    margin-top: 24px;
  }

  // таймер
  .timer_meaning {
    height: 58px;
    font-size: 21px;
    line-height: 25px;
    border-radius: 8px;
  }

  .timer_dots {
    height: 58px;
  }
  .timer_row {
    margin: 18px 22px 14px 22px;
  }
}

@media all and (max-width: 1440px) {
  .select-tariff-component {
    margin-top: 21px;
  }

  .item_title {
    font-size: 16px;
    line-height: 20px;
  }

  .sidebar_item {
    margin-top: 21px;
    border-radius: 10px;
  }

  .promo_input {
    height: 46px;
    padding: 0 16px;
    font-size: 15px;
    line-height: 19px;
    border-radius: 6px;
  }

  .block_promo {
    grid-gap: 10px;
  }

  .promo_button {
    width: 48px;
    height: 48px;
    border-radius: 6px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  // блок с промокодом
  .sidebar_header {
    font-size: 13px;
    line-height: 17px;
    margin: 14px 20px 10px 20px;
  }

  .block_promo {
    grid-gap: 10px;
    margin: 16px 20px;
  }

  .promo_button {
    width: 48px;
    height: 48px;
    border-radius: 6px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  // чекбокс с пользовательским соглашением
  .agreement {
    margin-top: 21px;

    .checkbox_text {
      font-size: 15px;
      line-height: 19px;
    }

    .question_checkbox+span::before {
      width: 20px;
      height: 20px;
    }
  }

  // таймер
  .timer_meaning {
    height: 52px;
    font-size: 19px;
    line-height: 23px;
    border-radius: 6px;
  }

  .timer_dots {
    height: 52px;
  }

  .timer_row {
    margin: 16px 20px 14px 20px;
  }

  .timer_clarification {
    font-size: 13px;
    line-height: 17px;
    margin-top: 4px;
  }

  .timer_dot {
    width: 3px;
    height: 3px;
  }

  .timer_dot:not(:last-child) {
    margin-bottom: 5px;
  }
}

@media all and (max-width: 1280px) {
  .select-tariff-component {
    margin-top: 18px;
  }

  .sidebar_item {
    margin-top: 18px;
  }

  .promo_input {
    height: 42px;
    padding: 0 16px;
    font-size: 14px;
    line-height: 18px;
  }

  .promo_button {
    width: 44px;
    height: 44px;
    border-radius: 6px;

    .promo_svg svg {
      width: 18px;
      height: auto;
    }
  }

  // блок с промокодом
  .sidebar_header {
    font-size: 12px;
    line-height: 15px;
    margin: 14px 18px 10px 18px;
  }

  .promo_input {
    height: 42px;
    padding: 0 16px;
    width: calc(100% - 32px);
    font-size: 14px;
    line-height: 18px;
  }

  .promo_button {
    width: 44px;
    height: 44px;
    border-radius: 6px;

    .promo_svg svg {
      width: 18px;
      height: auto;
    }
  }

  .block_promo {
    margin: 16px 18px;
  }

  .button__type_remove {
    width: 18px;
    height: 18px;

    svg {
      width: 8px;
      height: 8px;
    }
  }

  // чекбокс с пользовательским соглашением
  .agreement {
    margin-top: 18px;

    .checkbox_text {
      font-size: 14px;
      line-height: 18px;
    }

    .question_checkbox+span::before {
      width: 20px;
      height: 20px;
    }
  }

  // таймер
  .timer_row {
    grid-gap: 8px;
    margin: 16px 18px 12px 18px;
  }
  .timer_meaning {
    height: 50px;
    font-size: 17px;
    line-height: 21px;
    border-radius: 6px;
  }

  .timer_dots {
    height: 50px;
  }

  .timer_clarification {
    font-size: 12px;
    line-height: 15px;
    margin-top: 3px;
  }

  .timer_dot {
    width: 3px;
    height: 3px;
  }

  .timer_dot:not(:last-child) {
    margin-bottom: 5px;
  }
}

@media all and (max-width: 1160px) {
  .select-tariff-component {
    margin-top: 21px;
  }

  .tariff_component .block_promocode__desktop {
    display: none;
  }

  .tariff_component .block_promocode__tablet {
    display: flex;
  }

  .tariff_component .block_timer__desktop {
    display: none;
  }

  .tariff_component .block_timer__mobile_tablet {
    display: flex;
  }

  .promo_button {
    width: 48px;
    height: 48px;
    border-radius: 6px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  // блок с промокодом
  .block_promocode {
    display: flex;
    flex-direction: column;
    margin-top: auto;
    padding-top: 40px;
  }

  .sidebar_header {
    text-align: center;
    font-size: 13px;
    line-height: 17px;
    margin: 14px 0 12px 0;
  }

  .block_promocode .sidebar_header {
    text-align: start;
    margin-bottom: 6px;
    text-transform: none;
    font-size: 14px;
    line-height: 18px;
  }

  .promo_input {
    height: 46px;
    padding: 0 16px;
    width: calc(100% - 32px);
    font-size: 15px;
    line-height: 19px;
    border-radius: 6px;
  }

  .block_promo {
    margin: 0;
    grid-gap: 10px;
  }

  .promo_button {
    width: 48px;
    height: 48px;
    border-radius: 6px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  .button__type_remove {
    width: 22px;
    height: 22px;

    svg {
      width: 10px;
      height: 10px;
    }
  }

  // чекбокс с пользовательским соглашением
  .agreement {
    margin-top: 21px;

    .checkbox_text {
      font-size: 15px;
      line-height: 19px;
    }

    .question_checkbox+span::before {
      width: 20px;
      height: 20px;
    }

  }

  // таймер
  .sidebar_item {
    margin-top: 21px;
  }

  .block_timer {
    padding: 18px 24px 18px 24px;
    margin-top: 0;
  }

  .timer_header {
    text-align: center;
    font-size: 13px;
    line-height: 17px;
    margin: 0 0 10px 0;
  }

  .timer_meaning {
    height: 58px;
    font-size: 19px;
    line-height: 23px;
    border-radius: 6px;
  }

  .timer_dots {
    height: 58px;
  }

  .timer_row {
    margin: 18px 24px;
  }

  .timer_clarification {
    font-size: 13px;
    line-height: 17px;
    margin-top: 4px;
  }

  .timer_dot {
    width: 3px;
    height: 3px;
  }

  .timer_dot:not(:last-child) {
    margin-bottom: 5px;
  }

  .timer_row {
    grid-gap: 15px;
  }

  .block_management {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: white;
    position: fixed;
    z-index: 18;
    bottom: 0;
    width: calc(100% - 120px);
    padding: 20px 60px;
    margin-left: -60px;
    border-top: 1px solid $color_Gray_4;
  }

  .block-content {
    margin-bottom: 40px;
  }
}

@media all and (max-width: 960px) {
  .select-tariff-component {
    margin-top: 18px;
  }

  .item_title {
    font-size: 15px;
    line-height: 19px;
  }

  .promo_input {
    height: 42px;
    padding: 0 16px;
    font-size: 14px;
    line-height: 18px;
  }

  .promo_button {
    width: 44px;
    height: 44px;
    border-radius: 6px;
    .promo_svg svg {
      width: 18px;
      height: auto;
    }
  }

  .sidebar_item {
    margin-top: 18px;
  }

  // блок с промокодом
  .sidebar_header {
    font-size: 12px;
    line-height: 15px;
    margin: 12px 0 10px 0;
  }

  .timer_row {
    margin: 16px 24px;
  }

  .block_promocode .sidebar_header {
    text-align: start;
    margin-bottom: 4px;
    text-transform: none;
    font-size: 13px;
    line-height: 17px;
  }

  .promo_input {
    height: 42px;
    padding: 0 16px;
    width: calc(100% - 32px);
    font-size: 14px;
    line-height: 18px;
  }

  .promo_button {
    width: 44px;
    height: 44px;
    border-radius: 6px;

    .promo_svg svg {
      width: 18px;
      height: auto;
    }
  }

  .button__type_remove {
    width: 20px;
    height: 20px;

    svg {
      width: 9px;
      height: 9px;
    }
  }

  // чекбокс с пользовательским соглашением
  .agreement {
    margin-top: 18px;

    .checkbox_text {
      font-size: 14px;
      line-height: 18px;
    }

    .question_checkbox+span::before {
      width: 20px;
      height: 20px;
    }
  }

  // таймер
  .block_timer {
    border-radius: 8px;
  }

  .timer_header {
    font-size: 12px;
    line-height: 15px;
    margin-bottom: 10px;
  }

  .timer_meaning {
    height: 50px;
    font-size: 17px;
    line-height: 21px;
    border-radius: 6px;
  }
  .timer_dots {
    height: 50px;
  }

  .timer_clarification {
    font-size: 12px;
    line-height: 15px;
    margin-top: 3px;
  }

  .timer_dot {
    width: 3px;
    height: 3px;
  }

  .timer_dot:not(:last-child) {
    margin-bottom: 5px;
  }

  .block_management {
    width: calc(100% - 60px);
    padding: 18px 30px;
    margin-left: -30px;
  }

  .block-content {
    margin-bottom: 70px;
  }
}

@media all and (max-width: 720px) {
  .item_title {
    font-size: 14px;
    line-height: 18px;
  }
}

// mobile
@media all and (max-width: 600px) {
  .tariff_component .block__theme_mobile-steps {
    display: flex;
  }

  .tariff_component .block_promocode__tablet {
    display: none;
  }

  .tariff_component .block_promocode__mobile {
    display: flex;
  }

  .select-tariff-component {
    margin-top: 16px;
  }

  .sidebar_item {
    margin-top: 16px;
  }

  .item_svg {
    margin-right: 8px;
  }

  .main_content {
    grid-gap: 16px;
  }

  .tariff_slide {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .swiper-slide {
    width: 280px;
  }

  .item_title {
    font-size: 15px;
    line-height: 19px;
  }

  .sidebar_header {
    padding: 0 14px;
  }

  .sidebar_item {
    border-radius: 8px;
  }

  .sidebar_row {
    grid-gap: 8px;
  }

  // блок с промокодом
  .main_container .block_promocode {
    padding: 0;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    background-color: white;
  }

  .block_promocode .sidebar_header {
    margin: 12px 14px 10px 14px;
    text-transform: uppercase;
    font-size: 12px;
    line-height: 15px;
    padding: 0;
  }

  // таймер
  .block_timer {
    padding: 18px 14px 18px 14px;
  }

  .timer_row {
    grid-gap: 8px;
    margin: 15px 14px;
  }

  .block_promo {
    margin: 15px 14px;
  }

  .block_management {
    width: calc(100% - 30px);
    padding: 16px 15px;
    margin-left: -15px;
    border-top: 1px solid $color_Gray_4;
  }

  .block-content {
    margin-bottom: 40px;
  }
}

@media all and (max-width: 360px) {
  .swiper-slide {
    width: 270px;
  }
}

@media all and (max-width: 340px) {
  .swiper-slide {
    width: 260px;
  }

  .item_svg {
    margin-right: 8px;
  }

  .item_title {
    font-size: 14px;
    line-height: 18px;
  }
}

</style>